var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 93 93",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#play_svg__clip0_9_222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5 0a46.5 46.5 0 100 93 46.5 46.5 0 000-93zm0 85.25a38.75 38.75 0 110-77.5 38.75 38.75 0 010 77.5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 60.493h0V32.518h0v-.011c0-.09.03-.23.18-.4.154-.177.421-.364.804-.485.381-.12.815-.154 1.237-.09.422.064.769.218 1.007.4h0l.003.003 18.4 13.992s0 0 0 0c.313.24.369.462.369.573 0 .111-.056.333-.369.572 0 0 0 0 0 0l-18.4 13.993-.003.003a2.219 2.219 0 01-1.007.4 2.78 2.78 0 01-1.237-.09c-.383-.12-.65-.308-.805-.485-.148-.17-.18-.31-.179-.4z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "play_svg__clip0_9_222"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h93v93H0z"
  })))));
};

export default SvgPlay;